import { render } from "./Nutricion.vue?vue&type=template&id=12bed08d&scoped=true"
import script from "./Nutricion.vue?vue&type=script&lang=js"
export * from "./Nutricion.vue?vue&type=script&lang=js"

import "./Nutricion.vue?vue&type=style&index=0&id=12bed08d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bed08d"]])

export default __exports__